import { createContext, useContext } from 'react';

const ReservationContext = createContext();

export function ReservationProvider({ value, children }) {
  return (
    <ReservationContext.Provider value={value}>
      {children}
    </ReservationContext.Provider>
  );
}

export function useReservation() {
  return useContext(ReservationContext);
}
